var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-layout",
    style: _vm.colorObject
  }, [_c('div', {
    staticClass: "s-container"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('Header', {
    attrs: {
      "meta": _vm.meta,
      "page-title": _vm.moduleConfig.page_title,
      "page-image": _vm.moduleConfig.page_image,
      "page-kv-image": _vm.moduleConfig.page_kv_image,
      "header-section": _vm.moduleConfig.header_section
    }
  }), _c('div', {
    staticClass: "d-flex flex-column view"
  }, [_vm.headerImage ? _c('div', {
    staticClass: "banner text-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.headerImage
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "d-flex flex-column p-3 menu flex-fill",
    style: {
      'background-image': 'url(' + _vm.contentImage + ')'
    }
  }, [_c('div', {
    staticClass: "px-5 mb-3"
  }, [_c('b-card', {
    staticClass: "points text-center"
  }, [_c('span', {
    staticClass: "points__title"
  }, [_vm._v("累積點數")]), _c('div', {
    staticClass: "points__number"
  }, [_vm._v(_vm._s(_vm.formattedAvailablePoints))])])], 1), _vm._l(_vm.options, function (i) {
    return _c('router-link', {
      key: i.text,
      staticClass: "menu__item mb-2",
      attrs: {
        "to": {
          name: i.value,
          params: {
            org_code: _vm.$route.params.org_code
          }
        }
      }
    }, [_c('span', {
      staticClass: "menu__title"
    }, [_vm._v(_vm._s(i.text))]), _c('svg', {
      attrs: {
        "width": "18",
        "height": "19",
        "viewBox": "0 0 18 19",
        "fill": "none",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('path', {
      attrs: {
        "d": "M13.2773 9.85059C13.2773 9.65723 13.1982 9.48144 13.0576 9.34961L6.44824 3.00391C6.32519 2.88086 6.17578 2.81055 5.99121 2.81055C5.62207 2.81055 5.34082 3.0918 5.34082 3.45215C5.34082 3.62793 5.41113 3.79492 5.52539 3.91797L11.6953 9.8418L5.52539 15.7744C5.41113 15.8975 5.34082 16.0557 5.34082 16.2314C5.34082 16.6006 5.62207 16.8818 5.99121 16.8818C6.17578 16.8818 6.3252 16.8027 6.44824 16.6885L13.0576 10.334C13.1982 10.1934 13.2773 10.0352 13.2773 9.85059Z",
        "fill": "white"
      }
    })])]);
  })], 2)])], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }